import { z } from "zod";
/**
 * Compile-time catalog of features currently managed by the Beta system.
 * Permanent graduation removes a key from this array and from feature-specific
 * guards. The Super Admin Beta Features page only lists keys present here.
 */
export const BETA_FEATURE_KEYS = ["POST_COMMENTS"];
export const betaFeatureKeySchema = z.enum(BETA_FEATURE_KEYS);
export function isBetaFeatureKey(value) {
    return BETA_FEATURE_KEYS.includes(value);
}
/**
 * UI metadata only. Localized copy lives in en.json / he.json via the keys.
 */
export const BETA_FEATURE_CATALOG = [
    {
        key: "POST_COMMENTS",
        nameKey: "superAdmin.betaFeatures.features.POST_COMMENTS.name",
        descriptionKey: "superAdmin.betaFeatures.features.POST_COMMENTS.description",
    },
];
export const superAdminBetaFeatureItemSchema = z.object({
    featureKey: betaFeatureKeySchema,
    betaEnabled: z.boolean(),
    updatedAt: z.string(),
});
export const superAdminBetaFeatureListResponseSchema = z.object({
    items: z.array(superAdminBetaFeatureItemSchema),
});
export const updateSuperAdminBetaFeatureRequestSchema = z
    .object({
    betaEnabled: z.boolean(),
})
    .strict();
export const updateSuperAdminOrganizationBetaRequestSchema = z
    .object({
    isBetaOrganization: z.boolean(),
})
    .strict();
//# sourceMappingURL=beta-features-contracts.js.map